import { useEffect } from "react";
import useConfig from "./useConfig";
import { profileConfig } from "@/api/instances";

/**
 * Sets up axios with the correct config per environment
 * NOTE: Can only be used within a ConfigProvider (aka when config is available)
 */
export default function useInitAxios() {
  const config = useConfig();

  useEffect(() => {
    profileConfig.defaults.headers.common["Ocp-Apim-Subscription-Key"] =
      config.homeSubscriptionKey;
    profileConfig.defaults.baseURL = config.homeEndpoint;
  }, [config]);
}
